export const GET_EVALUATION = 'GET_EVALUATION';